// Quote CSV Templates of various types to use for importing or creating csv files

/**
 * Default Paintscout Public Quote Export CSV Template
 */
const DEFAULT_QUOTES_TEMPLATE = [
  'Number',
  'Status',
  'Date',
  'Std Date',
  'Type',
  'Client',
  'Email',
  'Address',
  'City',
  'State',
  'Zip Code',
  'Phone Number',
  'Job Address',
  'Lead Source',
  'Accepted via',
  'Estimator',
  'Prep (Hours)',
  'Labor (Hours)',
  'Total (Hours)',
  'Labor ($)',
  'Materials ($)',
  'Sub Total ($)',
  'Additional Work Labor ($)',
  'Additional Work Materials ($)',
  'Additional Work Total ($)',
  'After Additional Work ($)',
  'Discount Description',
  'Discount Rate (%)',
  'Discount Total ($)',
  'After Discount ($)',
  'Tax Rate (%)',
  'Tax Description',
  'Total Tax ($)',
  'After Tax ($)',
  'Sales Rate ($/hr)',
  'Sales Rate After Discount ($/hr)',
  'Amount Paid ($)',
  'Balance Due ($)',
  'Total Dimensions Lnft',
  'Total Dimensions Sqft',
  'Total Dimensions Sqft Walls',
  'Total Dimensions Sqft Ceiling',
  'Total Dimensions Sqft Floor',
  'Exterior Sub Total ($)',
  'Interior Sub Total ($)',
  'Exterior Total (Hours)',
  'Interior Total (Hours)',
  'Integration Source Provider',
  'Integration Source ID'
]

/**
 * Estimate Rocket Quote Import CSV Template
 */
const ER_QUOTES_TEMPLATE = [
  'Number',
  'Project Name',
  'Current State',
  'First Name',
  'Last Name',
  'Client Company',
  'Email',
  'Phone',
  'Subtotal',
  'Taxable Amount',
  'Nontaxable Amount',
  'Tax Authority',
  'Tax Rate',
  'Tax Amount',
  'Total',
  'Credit',
  'Paid',
  'Due',
  'Estimated Labor Hours',
  'Estimated Labor Cost',
  'Estimated Expenses',
  'Estimated Total Cost',
  'Estimated Profit',
  'Estimated Gross Margin',
  'Actual Labor Hours',
  'Actual Labor Cost',
  'Actual Expenses',
  'Actual Total Cost',
  'Actual Profit',
  'Actual Gross Margin',
  'Project Owner',
  'Created On',
  'Estimated By',
  'Estimated On',
  'Accepted On',
  'Work Completed By',
  'Work Completed On',
  'Invoiced On',
  'Location Address1',
  'Location Address2',
  'Location City',
  'Location State',
  'Location Zip',
  'Billing Address1',
  'Billing Address2',
  'Billing City',
  'Billing State',
  'Billing Zip',
  'Client Tags',
  'Project Tags',
  'Source'
]

/**
 * Default Contacts Import CSV Template
 */
const CONTACTS_TEMPLATE = [
  'First Name',
  'Last Name',
  'Email',
  'Phone',
  'Company',
  'Address',
  'City',
  'State',
  'Zip',
  'Country'
]

export { DEFAULT_QUOTES_TEMPLATE, ER_QUOTES_TEMPLATE, CONTACTS_TEMPLATE }
